import { Directive, Input } from "@angular/core";
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { AppSettingsService } from 'src/app/services/app-settings.service';
import { DateFormatType } from '../utils/moment';

@Directive({
  selector: '[appMomentFormats]',
    providers: [
        {
            provide: MAT_DATE_FORMATS,
            useFactory: (settings: AppSettingsService, directive: AppMomentFormatsDirective) => {
                return settings.momentFormats[directive.appMomentFormats];
            },
            deps: [AppSettingsService, AppMomentFormatsDirective]
        },
    ],
  standalone: false
})
export class AppMomentFormatsDirective {
  @Input() appMomentFormats: string | DateFormatType = DateFormatType.Date;
};

